import React, { useEffect, useState } from 'react';
import { goToLink } from '../utils/Functions';
import Button from './bper-button';
import parseHTML from 'html-react-parser';
import iconAreaSelf from './../images/filiali/ICON.svg';


function ResultsItem({
	el,
	stringOpenTime,
	sameLunediVenerdi,
	sameSabatoDomenicaChiuso,
	linkIndicazioniStradali,
	cssClass,
	setMarkerSelected,
	objDistanze,
	configurations,
	currentSubsidiary,
	translations,
	showServiceInfo,
	setShowServiceInfo
}) {
	const [distance, setDistance] = useState(undefined);

	const handleShowServiceInfo = (elementId, e, obj) => {
		e.preventDefault();
		e.stopPropagation();
		let elem = document.querySelector('#' + elementId);
		let rect = elem.getBoundingClientRect();

		const serviceInfo = {
			...obj,
			rect: rect
		}

		setShowServiceInfo(serviceInfo);
	}

	//distanza dal punto selezionato sulla mappa dalla ricerca (oppure da posizione utente) - distanza "aerea"
	//const distance = (parseFloat(window.google.maps.geometry.spherical.computeDistanceBetween(new window.google.maps.LatLng(place.lat, place.lng), new window.google.maps.LatLng(el.latitude, el.longitude))) / 1000).toFixed(1);

	//NON CANCELLARE - DA RIPRISTINARE - SERVE PER RECUPERARE DISTANZA IN KM! ORA A COMMENTO PER EVITARE TROPPE CHiAMATE
	/*useEffect(() => {
		let ignore = false;
		const service = new window.google.maps.DistanceMatrixService();

		objDistanze &&
			service.getDistanceMatrix(
				{
					origins: [objDistanze.origin],
					destinations: [objDistanze.destination],
					travelMode: 'DRIVING',
					avoidHighways: true,
					avoidTolls: true
				},
				callback
			);

		function callback(response, status) {
			if (!ignore) {
				if (status === 'OK') {
					const element = response?.rows?.[0]?.elements?.[0];
					if (element?.distance) {
						setDistance({
							km: element.distance.text,
							duration: element.duration.text
						});
					}
				}
			}
		}
		return () => {
			ignore = true;
		};
	}, [objDistanze]);*/
	//NON CANCELLARE - DA RIPRISTINARE - SERVE PER RECUPERARE DISTANZA IN KM! ORA A COMMENTO PER EVITARE TROPPE CHiAMATE





	/*async function getDistance() {
		var service = new window.google.maps.DistanceMatrixService();
		service.getDistanceMatrix(
			{
				origins: [objDistanze.origin],
				destinations: [objDistanze.destination],
				travelMode: 'DRIVING',
				avoidHighways: true,
				avoidTolls: true
			},
			callback
		);

		function callback(response, status) {
			status === 'OK' &&
				response.rows &&
				response.rows[0] &&
				response.rows[0].elements &&
				response.rows[0].elements[0] &&
				response.rows[0].elements[0].distance &&
				setDistance({
					km: response.rows[0].elements[0].distance.text,
					duration: response.rows[0].elements[0].duration.text
				});
		}
	}*/
	const stopPropagation = (e) => {
		e && e.stopPropagation();
		e && e.nativeEvent.stopImmediatePropagation();
	}

	const subsidiaryId = el.id;

	return (
		<div
			id={subsidiaryId}
			className={cssClass}
			onClick={() =>
				setMarkerSelected({
					id: el.id,
					lat: el.latitude,
					lng: el.longitude
				})
			}
		>
			<div className="store-item-logo">
				<svg
					alt={'Marker_' + el.id}
					className="marker-icon"
					xmlns="http://www.w3.org/2000/svg"
					width="36"
					height="48"
					viewBox="0 0 36 48"
				>
					<path
						id="icn-pointer"
						d="M-18,48c1.714,0,6.15-4.846,10.32-11.272a68.073,68.073,0,0,0,5.363-9.846A23.751,23.751,0,0,0,0,18,17.882,17.882,0,0,0-5.272,5.272,17.882,17.882,0,0,0-18,0,17.882,17.882,0,0,0-30.728,5.272,17.882,17.882,0,0,0-36,18a23.751,23.751,0,0,0,2.318,8.881,68.073,68.073,0,0,0,5.363,9.846C-24.15,43.154-19.714,48-18,48Zm0-36a6.007,6.007,0,0,1,6,6,6.007,6.007,0,0,1-6,6,6.007,6.007,0,0,1-6-6A6.007,6.007,0,0,1-18,12Z"
						transform="translate(36 0)"
						fill="#006369"
					/>
				</svg>
			</div>
			<div className="store-info">
				{el.subsidiaryDescription && <h4>{el.subsidiaryDescription}</h4>}
				<div className="row">
					{el.distance && el.distance !== "undefined" &&
						<div className="left">
							<p className="italic distance" title={el.distance} style={{fontWeight:"700"}}>
								{(el.distance + ' ').replace('.', ',')}
							</p>
						</div>
					}
					{el.areaSelf && (
						<div className="right">
							<a>
								<span>{translations.areaSelfLabel}</span>
								<span className="icon-area-self">
									<svg width="92px" height="92px" viewBox="0 0 92 92" version="1.1" xmlns="http://www.w3.org/2000/svg">
										<defs>
											<filter x="-120.0%" y="-120.0%" width="340.0%" height="340.0%" filterUnits="objectBoundingBox" id="filter-1">
												<feGaussianBlur stdDeviation="8" in="SourceGraphic"></feGaussianBlur>
											</filter>
											<filter x="-180.0%" y="-180.0%" width="460.0%" height="460.0%" filterUnits="objectBoundingBox" id="filter-2">
												<feGaussianBlur stdDeviation="12" in="SourceGraphic"></feGaussianBlur>
											</filter>
										</defs>
										<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
											<g id="08_Pagina-Filiale" transform="translate(-212.000000, -347.000000)">
												<g id="Group-9" transform="translate(240.000000, 375.000000)">
													<path d="M36,18 C36,27.9411429 27.9405,36 18,36 C8.05821429,36 0,27.9411429 0,18 C0,8.05885714 8.05821429,0 18,0 C27.9405,0 36,8.05885714 36,18" id="Fill-1" fill="#006369"></path>
													<circle id="Oval" fill="#00B77A" filter="url(#filter-1)" cx="18" cy="18" r="10"></circle>
													<circle id="Oval" fill="#00B77A" filter="url(#filter-2)" cx="18" cy="18" r="10"></circle>
													<g id="Group-30" transform="translate(7.000000, 6.000000)" fill="#FFFFFF">
														<path d="M19.4981349,6.77092114 L12.1789234,6.77092114 C11.9865806,6.77092114 11.8100777,6.876144 11.7195634,7.04585829 L9.694872,10.8129497 L10.2170263,12.0422469 L12.4900663,7.81296686 L18.604872,7.81296686 L15.1110206,13.9860411 C16.1066777,14.3305611 16.6791806,15.1638583 16.6791806,16.2952869 C16.6791806,17.7932983 15.6343063,18.760104 14.0174949,18.760104 L8.744472,18.760104 C8.54703771,18.760104 8.35469486,18.7414354 8.170272,18.7052297 L8.170272,20.1534583 L21.1358777,20.1534583 L21.1358777,9.93892114 C21.1358777,9.86933829 21.1223006,9.80032114 21.0951463,9.73639543 L19.9795577,7.089984 C19.8788606,6.86482971 19.6452206,6.77092114 19.4981349,6.77092114" id="Fill-3"></path>
														<path d="M14.0172686,17.7172663 C15.0389486,17.7172663 15.6363429,17.218872 15.6363429,16.2950606 C15.6363429,15.5228606 15.2561829,15.1127177 14.7142286,14.9475291 L10.1144057,14.4655406 L8.26452,10.1135006 C7.50533143,8.24494629 6.17364,7.43936914 4.72710857,7.43936914 C2.74032,7.43936914 1.24230857,8.60304343 0.821982857,11.2522834 L-1.08173026e-12,20.1537977 L6.61206857,20.1537977 L6.61206857,17.971272 L4.10538857,12.8102606 L5.08350857,12.5432434 C5.62998857,13.674672 6.50232,15.4798663 7.01542286,16.5253063 C7.38936,17.2873234 7.97713714,17.7172663 8.74481143,17.7172663 L14.0172686,17.7172663 Z" id="Fill-5"></path>
														<path d="M7.81811486,7.21512 C5.82623486,7.21512 4.21112057,5.59944 4.21112057,3.60756 C4.21112057,1.61568 5.82623486,2.28226327e-13 7.81811486,2.28226327e-13 C9.81056057,2.28226327e-13 11.4256749,1.61568 11.4256749,3.60756 C11.4256749,5.59944 9.81056057,7.21512 7.81811486,7.21512 Z" id="Fill-7"></path>
													</g>
												</g>
											</g>
										</g>
									</svg>
								</span>
							</a>
						</div>
					)}
				</div>
				{el.address && (
					<div className="row">
						{el.address}
						<br />
						{el.zipCode} {el.cityDescription} {el.c_provincia}
					</div>
				)}
				{!currentSubsidiary && (
					<>
						{
							stringOpenTime && <div className="row string-open-time" >{parseHTML(stringOpenTime.toString())}</div>
						}
						{
							el.cashLight &&
							<div className="row">
								<span className="small">
									{el.cashLight}
								</span>
							</div>
						}
					</>
				)}
				<div className={"orari-contatti " + el.subsdiaryType}>
					{(
						(el.subsdiaryType === "FILIALE" && currentSubsidiary) ||
						(el.subsdiaryType === "CP") ||
						(el.subsdiaryType === "CI")
					) && (
							<>
								<div className="row horizontal contacts" style={{fontWeight: 400}}>
									{(el.contacts.phone || el.contacts.fax) && <b className="italic" style={{fontWeight:"700"}}>{translations.contacts}</b>}
									{el.contacts.phone && (
										<a
											href={'tel:' + el.contacts.phone}
											className="phone"
											style={{fontWeight: 400}}
										>
											{el.contacts.phone}
										</a>
									)}
									{el.contacts.fax && (
										<a href={'fax:' + el.contacts.fax} className="fax" style={{fontWeight: 400}}>
											{el.contacts.fax}
										</a>
									)}
									{
										/*
										el.contacts.email && (
											<a href={'mailto:' + el.contacts.email} className="email">
												{el.contacts.email}
											</a>
										)
										*/
									}
								</div>
							</>
						)}
					{(
						(el.subsdiaryType === "FILIALE" && currentSubsidiary) ||
						(el.subsdiaryType === "CP")
					) &&  el.timetables && (
							<>
								<div className="row horizontal orari-wrapper">
									<b className="orari italic"  style={{fontWeight:"700"}}>{translations.times}</b>
									<div className="orari-content">
										{sameLunediVenerdi ? (
											<>
												<b  style={{fontWeight:"700"}}>{translations.MondayFriday}</b>
												<ul>
													<li>
														{
															el.timetables && el.timetables.openMondayMorning.split(
																' '
															)[0]
														}
												-
												{
															el.timetables && el.timetables.openMondayMorning.split(
																' '
															)[1]
														}
													</li>
													<li>
														{
															el.timetables && el.timetables.openMondayAfternoon.split(
																' '
															)[0]
														}
												-
												{
															el.timetables && el.timetables.openMondayAfternoon.split(
																' '
															)[1]
														}
													</li>
												</ul>
											</>
										) : (
												<>
													<b  style={{fontWeight:"700"}}>{translations.Monday}</b>
													<ul>
														{el.timetables && el.timetables.openMondayMorning.trim() ===
															'chiuso' &&
															el.timetables && el.timetables.openMondayAfternoon.trim() ===
															'chiuso' ? (
																<li>{translations.close}</li>
															) : (
																<>
																	{el.timetables && el.timetables.openMondayMorning !==
																		'chiuso' ? (
																			<li>
																				{
																					el.timetables && el.timetables.openMondayMorning.split(
																						' '
																					)[0]
																				}
															-
																				{
																					el.timetables && el.timetables.openMondayMorning.split(
																						' '
																					)[1]
																				}
																			</li>
																		) : (
																			<li>
																				{translations.close}
																			</li>
																		)}
																	{el.timetables && el.timetables.openMondayAfternoon !==
																		'chiuso' ? (
																			<li>
																				{
																					el.timetables && el.timetables.openMondayAfternoon.split(
																						' '
																					)[0]
																				}
															-
																				{
																					el.timetables && el.timetables.openMondayAfternoon.split(
																						' '
																					)[1]
																				}
																			</li>
																		) : (
																			<li>
																				{translations.close}
																			</li>
																		)}
																</>
															)}
													</ul>

													<b  style={{fontWeight:"700"}}>{translations.Tuesday}</b>
													<ul>
														{el.timetables && el.timetables.openTuesdayMorning.trim() ===
															'chiuso' &&
															el.timetables && el.timetables.openTuesdayAfternoon.trim() ===
															'chiuso' ? (
																<li>{translations.close}</li>
															) : (
																<>
																	{el.timetables && el.timetables.openTuesdayMorning ? (
																		<li>
																			{
																				el.timetables && el.timetables.openTuesdayMorning.split(
																					' '
																				)[0]
																			}
															-
																			{
																				el.timetables && el.timetables.openTuesdayMorning.split(
																					' '
																				)[1]
																			}
																		</li>
																	) : (
																			<li>
																				{translations.close}
																			</li>
																		)}
																	{el.timetables && el.timetables.openTuesdayAfternoon ? (
																		<li>
																			{
																				el.timetables && el.timetables.openTuesdayAfternoon.split(
																					' '
																				)[0]
																			}
															-
																			{
																				el.timetables && el.timetables.openTuesdayAfternoon.split(
																					' '
																				)[1]
																			}
																		</li>
																	) : (
																			<li>
																				{translations.close}
																			</li>
																		)}
																</>
															)}
													</ul>
													<b  style={{fontWeight:"700"}}>{translations.Wednesday}</b>
													<ul>
														{el.timetables && el.timetables.openWednesdayMorning.trim() ===
															'chiuso' &&
															el.timetables && el.timetables.openWednesdayAfternoon.trim() ===
															'chiuso' ? (
																<li>{translations.close}</li>
															) : (
																<>
																	{el.timetables && el.timetables.openWednesdayMorning ? (
																		<li>
																			{
																				el.timetables && el.timetables.openWednesdayMorning.split(
																					' '
																				)[0]
																			}
															-
																			{
																				el.timetables && el.timetables.openWednesdayMorning.split(
																					' '
																				)[1]
																			}
																		</li>
																	) : (
																			<li>
																				{translations.close}
																			</li>
																		)}
																	{el.timetables && el.timetables.openWednesdayAfternoon ? (
																		<li>
																			{
																				el.timetables && el.timetables.openWednesdayAfternoon.split(
																					' '
																				)[0]
																			}
															-
																			{
																				el.timetables && el.timetables.openWednesdayAfternoon.split(
																					' '
																				)[1]
																			}
																		</li>
																	) : (
																			<li>
																				{translations.close}
																			</li>
																		)}
																</>
															)}
													</ul>
													<b style={{fontWeight:"700"}}>{translations.Thursday}</b>
													<ul>
														{el.timetables && el.timetables.openThursdayMorning.trim() ===
															'chiuso' &&
															el.timetables && el.timetables.openThursdayAfternoon.trim() ===
															'chiuso' ? (
																<li>{translations.close}</li>
															) : (
																<>
																	{el.timetables && el.timetables.openThursdayMorning ? (
																		<li>
																			{
																				el.timetables && el.timetables.openThursdayMorning.split(
																					' '
																				)[0]
																			}
															-
																			{
																				el.timetables && el.timetables.openThursdayMorning.split(
																					' '
																				)[1]
																			}
																		</li>
																	) : (
																			<li>
																				{translations.close}
																			</li>
																		)}
																	{el.timetables && el.timetables.openThursdayAfternoon ? (
																		<li>
																			{
																				el.timetables && el.timetables.openThursdayAfternoon.split(
																					' '
																				)[0]
																			}
															-
																			{
																				el.timetables && el.timetables.openThursdayAfternoon.split(
																					' '
																				)[1]
																			}
																		</li>
																	) : (
																			<li>
																				{translations.close}
																			</li>
																		)}
																</>
															)}
													</ul>
													<b style={{fontWeight:"700"}}>{translations.Friday}</b>
													<ul>
														{el.timetables && el.timetables.openFridayMorning.trim() ===
															'chiuso' &&
															el.timetables && el.timetables.openFridayAfternoon.trim() ===
															'chiuso' ? (
																<li>{translations.close}</li>
															) : (
																<>
																	{el.timetables && el.timetables.openFridayMorning ? (
																		<li>
																			{
																				el.timetables && el.timetables.openFridayMorning.split(
																					' '
																				)[0]
																			}
															-
																			{
																				el.timetables && el.timetables.openFridayMorning.split(
																					' '
																				)[1]
																			}
																		</li>
																	) : (
																			<li>
																				{translations.close}
																			</li>
																		)}
																	{el.timetables && el.timetables.openFridayAfternoon ? (
																		<li>
																			{
																				el.timetables && el.timetables.openFridayAfternoon.split(
																					' '
																				)[0]
																			}
															-
																			{
																				el.timetables && el.timetables.openFridayAfternoon.split(
																					' '
																				)[1]
																			}
																		</li>
																	) : (
																			<li>
																				{translations.close}
																			</li>
																		)}
																</>
															)}
													</ul>
												</>
											)}
										{
											el.cashLight &&
											<div className="row">
												<span className="small">
													{el.cashLight}
												</span>
											</div>
										}
										{sameSabatoDomenicaChiuso ? (
											<>
												<b style={{fontWeight:"700"}}>{translations.SaturdaySunday}</b>
												<span className="small">
													{translations.close}
												</span>
											</>
										) : (
												<>
													<b style={{fontWeight:"700"}}>{translations.Saturday}</b>
													<ul>
														{el.timetables && el.timetables.openSaturdayMorning.trim() ===
															'chiuso' &&
															el.timetables && el.timetables.openSaturdayAfternoon.trim() ===
															'chiuso' ? (
																<li>{translations.close}</li>
															) : (
																<>
																	{el.timetables && el.timetables.openSaturdayMorning ? (
																		<li>
																			{
																				el.timetables && el.timetables.openSaturdayMorning.split(
																					' '
																				)[0]
																			}
															-
																			{
																				el.timetables && el.timetables.openSaturdayMorning.split(
																					' '
																				)[1]
																			}
																		</li>
																	) : (
																			<li>
																				{translations.close}
																			</li>
																		)}
																	{el.timetables && el.timetables.openSaturdayAfternoon ? (
																		<li>
																			{
																				el.timetables && el.timetables.openSaturdayAfternoon.split(
																					' '
																				)[0]
																			}
															-
																			{
																				el.timetables && el.timetables.openSaturdayAfternoon.split(
																					' '
																				)[1]
																			}
																		</li>
																	) : (
																			<li>
																				{translations.close}
																			</li>
																		)}
																</>
															)}
													</ul>
													<b style={{fontWeight:"700"}}>{translations.Sunday}</b>
													<ul>
														{el.timetables && el.timetables.openSundayMorning.trim() ===
															'chiuso' &&
															el.timetables && el.timetables.openSundayAfternoon.trim() ===
															'chiuso' ? (
																<li>{translations.close}</li>
															) : (
																<>
																	{el.timetables && el.timetables.openSundayMorning ? (
																		<li>
																			{
																				el.timetables && el.timetables.openSundayMorning.split(
																					' '
																				)[0]
																			}
															-
																			{
																				el.timetables && el.timetables.openSundayMorning.split(
																					' '
																				)[1]
																			}
																		</li>
																	) : (
																			<li>
																				{translations.close}
																			</li>
																		)}
																	{el.timetables && el.timetables.openSundayAfternoon ? (
																		<li>
																			{
																				el.timetables && el.timetables.openSundayAfternoon.split(
																					' '
																				)[0]
																			}
															-
																			{
																				el.timetables && el.timetables.openSundayAfternoon.split(
																					' '
																				)[1]
																			}
																		</li>
																	) : (
																			<li>
																				{translations.close}
																			</li>
																		)}
																</>
															)}
													</ul>
												</>
											)}
									</div>
								</div>
							</>
						)}
				</div>

				{((el.subsdiaryType === "FILIALE") || (el.subsdiaryType === "ATMCSA")) && el.services && (
					<ul className="services">
						{
							el.services.map((service, i) => (
								<>
									<li key={'service_' + service.serviceId} id={"service_" + subsidiaryId + "_" + service.serviceId}>
										<span
											style={{cursor:"pointer"}}
											className="icon"
											onClick={(e) => handleShowServiceInfo("service_" + subsidiaryId + "_" + service.serviceId, e, { serviceId: service.serviceId, itemId: subsidiaryId, abstract: service.popup })}
										>							
										<img src={"/documents/"+JSON.parse(service.icon).groupId+"/"+JSON.parse(service.icon).uuid} />
										</span>
										<span style={{ display: "flex", flexDirection: "column",cursor:"pointer" }}>
											<a
												style={{ marginBottom: "3px" }}
												className="text link-cta link-cta-icon green-dark"
												onClick={(e) => handleShowServiceInfo("service_" + subsidiaryId + "_" + service.serviceId, e, { serviceId: service.serviceId, itemId: subsidiaryId, abstract: service.popup })}
											>
												<span className="title">{service.title}</span>
											</a>
											<a
												className="text link-cta green-dark"
												onClick={(e) => handleShowServiceInfo("service_" + subsidiaryId + "_" + service.serviceId, e, { serviceId: service.serviceId, itemId: subsidiaryId, abstract: service.popup })}
											>
												<span className="subtitle">{service.subTitle}</span>
											</a>
										</span>
									</li>
								</>
							))
						}
					</ul>
				)}

				<div className="link-mobile">
					{el.contacts.phone && (
						<a
							href={'tel:' + el.contacts.phone}
							className="call link-cta link-cta-icon"
						>
							{translations.call}
						</a>
					)}
					{linkIndicazioniStradali &&
						<a
							className="directions link-cta link-cta-icon"
							onClick={() =>
								goToLink(linkIndicazioniStradali, '_blank')
							}
						>
							{translations.Directions}
						</a>
					}
				</div>
				<div className="buttons">
					<Button
						onClick={(e) => stopPropagation()}
						href={el.linkSubsidiaryCard}
						target="_self"
						className="subsidiary-detail"
						variant="contained"
						color="secondary"
						
					>
						{translations.DiscoverDetail}
					</Button>

					{linkIndicazioniStradali &&
						<Button
							className="directions"
							variant="outlined"
							onClick={() =>
								goToLink(linkIndicazioniStradali, '_blank')
							}
						>
							{translations.Directions}
						</Button>
					}
				</div>
			</div>
		</div >
	);
}

export default ResultsItem;
